var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
export default function AdminHome() {
    var t = useTranslation(["Administration", "common", "Configurator"]).t;
    return (_jsxs("div", __assign({ className: "mt-5 p-6 space-y-6 bg-[var(--colors-widget)]" }, { children: [_jsx("h1", __assign({ className: "text-2xl font-bold" }, { children: t("LBL_ADMIN_PAGE", {
                    ns: "Administration",
                }) })), _jsx("p", __assign({ className: "" }, { children: t("LBL_ADMIN_WELCOME", {
                    ns: "Administration",
                }) }))] })));
}
